import React, { useEffect, useState } from "react";
import InputContainer from "../../../citizen/AVPForms/layout/inputWrapper";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../../citizen/TCPForms/components/Button";
import { Col, Container, Row } from "react-bootstrap";
import SortingAlphabatically from "../../../citizen/AVPForms/reusableComponents/SortingAlphbatically";

const FilterForm = ({ onSubmit, userDetails, userType, location1, onReset }) => {
  const [disableSearch, setDisableSearch] = useState(true);
  const { handleSubmit, control, reset, watch, setValue } = useForm({
    defaultValues: {
      developmentAuthorityName: location1,
    },
  });

  const allValues = watch();

  const { createdFrom, createdTo, developmentAuthorityName } = allValues;

  const hasFromDate = !!createdFrom;
  const hasToDate = !!createdTo;
  const hasOrganization = !!developmentAuthorityName;

  useEffect(() => {
    const disableButton = !hasOrganization || (hasFromDate && !hasToDate) || (!hasFromDate && hasToDate);

    setDisableSearch(disableButton);
  }, [allValues]);

  const tenantId = Digit.ULBService.getStateId();
  const { data: { BPA: { Organizations: departmentListOptions } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [
    "Organizations",
  ]);
  function filterDepartmentsList(completeList) {
    const filterCompList = completeList?.filter(
      (e) => !e?.Name?.includes("UP Housing and Development Board") && !e?.Name?.includes("Uttar Pradesh Online Building Plan Approval System")
    );
    const officeNames = filterCompList?.map((office) => ({ value: office.Name, label: office.Name }));

    return officeNames;
  }
  useEffect(() => {
    if (departmentListOptions?.length && location1) {
      setValue("developmentAuthorityName", location1);
    }
  }, [departmentListOptions, location1, setValue]);

  const daList = departmentListOptions?.filter((item) => item.Type == "DA");
  const avpList = departmentListOptions?.filter((item) => item.Type == "AVP");

  const officesList = filterDepartmentsList(departmentListOptions);
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer"></div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputContainer label="From Date" control={control} placeholder="Select Date" name="createdFrom" type="datePicker" />
              </Col>
              <Col>
                <InputContainer label="To Date" control={control} placeholder="Select Date" name="createdTo" type="datePicker" disableFuture={true} />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputContainer
                  label="Organization Name"
                  control={control}
                  placeholder="Select Organization"
                  name="developmentAuthorityName"
                  data={SortingAlphabatically(officesList)}
                  type={userType !== "Admin" && userType !== "SuperAdmin" ? "textInput" : "selectInput"}
                  disabled={userType !== "SuperAdmin"}
                />
              </Col>
              <Col></Col>
              {/* <Col>
                <InputContainer
                  label="Permission Type"
                  control={control}
                  placeholder="Select Permission Type"
                  data={[{ value: "Land Use", label: "Land Use" }, ,]}
                  name="modulename"
                  type="selectInput"
                />
              </Col> */}
            </Row>
          </Container>
        </div>
        <div
          className="footerContainer2"
          style={{
            marginTop: "0px",
          }}
        >
          <div className="buttonWrapper" style={{ display: "flex", gap: "8px" }}>
            <ButtonWrapper
              variant="contained"
              disabled={disableSearch}
              color={disableSearch ? "secondary" : "success"}
              size="medium"
              label="Search"
              type="submit"
            />
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Reset"
              onClick={() => {
                reset();
                onReset();
              }}
            />
          </div>
        </div>
      </form>
    </section>
  );
};

export default FilterForm;
